import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateStrPipe',
})
export class TruncateStrPipe implements PipeTransform {
  transform(value: string, limit: number): any {
    if (value == null || value == undefined) {
      return value;
    } else if (value.length <= limit) {
      return value;
    } else {
      return value.slice(0, limit) + '...';
    }
  }
}
